import React from "react";
import styled from "styled-components";
import {logAction} from "../../../../logging/logEvent";

const LogOutContainer = styled.a`
    display: flex;
    flex-grow: 1;
    align-items: center;
    height: 34px;
    text-decoration: none;
    color: #4a4a4a;
    font-size: 14px;
    font-weight: bold;    
    padding-left: 14px;
`;

export const LogOut = () => {
    const onClick = (e) => {
        e.stopPropagation();
        logAction({type: "LOG_OUT"});
        window.location.href = "/TradeIdeasMonitor/monitor?action=logout";
    };

    return (
        <LogOutContainer className="t-logout-button"
                         onClick={onClick}>
            <div>Log Out</div>
        </LogOutContainer>
    );
};